import vbBookIndex from "../views/book/VbBookIndex.vue";
import Detail from "../views/book/Detail.vue";
export default [
  {
    path: "/app/:userDeptRoleId/quanlySoDen/:bookType",
    name: "quanlySoDen",
    component: () => import("../views/book/VbBookIndex.vue")
  },
  {
    path: "/app/:userDeptRoleId/quanlySoDen/:bookType/edit/:id",
    name: "quanlySoDenDetail",
    components: {
      default: vbBookIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/quanlySoDi/:bookType",
    name: "quanlySoDi",
    component: () => import("../views/book/VbBookIndex.vue")
  },
  {
    path: "/app/:userDeptRoleId/quanlySoDiDetail/:bookType/edit/:id",
    name: "quanlySoDiDetail",
    components: {
      default: vbBookIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/bookso",
    name: "bookSo",
    component: () => import("../views/book/VbBookDocindex")
  }
];



// WEBPACK FOOTER //
// ./src/router/book.js